import { IGetVillageForMapResponse as IVillage } from '@cian/api-models/countryside-search/v1/get-village-for-map';
import * as React from 'react';
import { IBSCenterInfo } from '../../../api/bs_centers';
import { IDeveloperInfo } from '../../../api/developers';
import { INewbuildingInfo } from '../../../api/newbuildings';
import { IJsonQuery } from '../../../json_query';
import { HeaderBSCenterContainer } from './bs_center/container';
import { HeaderDefaultContainer } from './default/container';
import { HeaderDeveloperContainer } from './developer/container';
import { HeaderNewbuildingContainer } from './newbuilding/container';
import { HeaderVillageContainer, isVillageInfoVisible } from './village';

export interface IHeaderProps {
  villageInfo?: IVillage | null;
  jsonQuery: IJsonQuery;
  newbuildingInfo: INewbuildingInfo | null;
  developerInfo: IDeveloperInfo | null;
  bsCenterInfo: IBSCenterInfo | null;
}

export const Header: React.StatelessComponent<IHeaderProps> = ({
  villageInfo,
  jsonQuery,
  newbuildingInfo,
  developerInfo,
  bsCenterInfo,
}) => {
  if (villageInfo && isVillageInfoVisible(villageInfo, jsonQuery)) {
    return <HeaderVillageContainer />;
  }

  if (newbuildingInfo) {
    return <HeaderNewbuildingContainer />;
  }

  if (developerInfo) {
    return <HeaderDeveloperContainer />;
  }

  if (bsCenterInfo) {
    return <HeaderBSCenterContainer />;
  }

  return <HeaderDefaultContainer />;
};
